import React, { useState } from 'react';
import Hero from '../Components/Home/Hero';
import BarChartComponents from '../Components/Home/BarChartComponents';
import PieChartComponent from '../Components/Home/BarchartSecond';

const Home = () => {
	const [activeTab, setActiveTab] = useState('DCR');

	return (
		<div>
			<Hero activeTab={activeTab} setActiveTab={setActiveTab} />

			{/* Responsive Chart Layout */}
			<div className='flex flex-wrap md:flex-nowrap justify-between items-center px-4 gap-4'>
				<BarChartComponents activeTab={activeTab} setActiveTab={setActiveTab} />
				<PieChartComponent activeTab={activeTab} setActiveTab={setActiveTab} />
			</div>
		</div>
	);
};

export default Home;
